import useBenefitUsages from 'contract/useBenefitUsages';

const TELEVET_BENEFIT_SLUG = 'televet';

export const useHasBenefit = () => {
  return useBenefitUsages(TELEVET_BENEFIT_SLUG);
};
